import React, { FC } from 'react';

import { useHeader } from '../components/common/navigation/hooks/header-service';
import Map from '../components/map/map';

const MapPage: FC = () => {
  useHeader('Карта');

  return (
    <>
      <Map />
    </>
  );
};

export default MapPage;
